import * as Sentry from '@sentry/react';

const SENTRY_DSN =
  'https://2a42766d25fdff5b1156664fa555dc50@o895196.ingest.us.sentry.io/4510956926271488';

export function initSentry(): void {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Captures PII such as IP addresses by default; disable in privacy-sensitive builds
    sendDefaultPii: true,
    // Only enable Sentry in non-development environments
    enabled: process.env.NODE_ENV !== 'development',
    environment: process.env.NODE_ENV,
  });
}
